export default "__VITE_ASSET__DT$QGJPw__"